import React from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';
import {
  Element,
  FontType,
  Color,
  TabGroupWithContent,
  Typography
} from '@americanexpress/aqx-components';
import { getSegmentNavData } from './../../redux/index';
import styles from './__styles__/index.scss?modules';

import ContentUnit from './ContentUnit';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';
import parseArrayToObject from 'src/universal/utils/parseArrayToObject';
import replaceStringWithVars from 'src/universal/utils/replaceStringWithVars';
import LazyScrollMetricTracker from 'src/universal/components/DTM/LazyScrollMetricTracker';

const formatDTMEvent = (dtmEvents, industries, currentIndex) => {
  const dtmEvent = parseArrayToObject(dtmEvents, 'tag').tabClick;
  return {
    ...dtmEvent,
    eventAsset: replaceStringWithVars({
      string: dtmEvent.eventAsset,
      varsObject: {
        industry: industries[currentIndex]
      }
    })
  };
};

const buildTabItems = (contentList, instId) => {
  return (contentList || []).map((item, i) => {
    return {
      Component: ({ isActive }) => (
        <Element className={clsx(styles.tabHeader, { [styles.selected]: isActive })}>
          {item.header}
        </Element>
      ),
      tabId: `tab-${instId}-${i}`
    };
  });
};

export const SegmentsNav = ({
  header,
  title,
  dtm,
  content,
  industries,
  dtmEvents,
  instId
}) => {
  let currIndex = 0;

  const tabProps = {
    tabItems: buildTabItems(content, instId),
    data: (content || []).map((item, i) => {
      return {
        ariaLabelledBy: `tab-${instId}-${i}`,
        id: `tabpanel-TabGroupWithContent-${instId}-${i}`,
        qeId: instId,
        content: <ContentUnit {...item} index={i} currIndex={currIndex} />
      };
    }),
    onTabIndexChange: selectedIndex => {
      currIndex = selectedIndex;
      const dtmEvent = formatDTMEvent(dtmEvents, industries, selectedIndex);
      sendDTMClickEvent(dtmEvent);
    },
    shouldStayHorizontal: false,
    qeId: instId
  };
  return (
    <Element
      className={clsx(styles.segmentNavOuter, styles[`currIndex${currIndex}`])}
    >
      <LazyScrollMetricTracker scrollDtm={dtm} />
      <Typography
        Component="h2"
        $family={FontType.BentonRegular}
        $size="30px"
        $lineHeight="38px"
        className={styles.topHeader}
        theme={{
          color: Color.Gray06,
          marginBottom: title ? 0 : 40
        }}
      >
        {header}
      </Typography>
      {title && (
        <Typography
          Component="h2"
          $family={FontType.BentonBold}
          $size="30px"
          $lineHeight="38px"
          className={styles.topHeader}
          theme={{
            color: Color.Gray06,
            paddingLeft: 20,
            paddingRight: 20,
            marginBottom: 40
          }}
        >
          {title}
        </Typography>
      )}

      <Element className={styles.tabbedContentWrapper}>
        <TabGroupWithContent {...tabProps} />
      </Element>
    </Element>
  );
};

const mapStateToProps = state => {
  return {
    ...getSegmentNavData(state)
  };
};

export default connect(mapStateToProps)(React.memo(SegmentsNav));
